import React from 'react';
import {connect} from "react-redux";
import Renderers from "../../helpers/Renderers";
import {bindActionCreators} from 'redux';
import * as tabActions from "../../redux/modules/tabs";

class DriverSubform extends React.Component {

	static contextTypes= {
		router: React.PropTypes.object
	};

	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	handleOpen(e, row) {
		e.preventDefault();
		this.props.actions.openTabForm('driver', row.surname + ' ' + row.name, {id: row.driver});
		//this.context.router.replace('/driver/'+row.driver);
	}

	render() {
		const values = this.props.state.get('values').toJS();
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td className="name">{values.surname}</td>
				<td className="name">{values.name}</td>
				<td className="name">{Renderers.Date(values.born)}</td>
				<td className="name">{values.groups.join ? values.groups.join(' ') : values.groups}</td>
				<td style={{width:32}}><a onClick={(e) => this.handleOpen(e, values)}><span className="fa fa-pencil"></span></a></td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

export default connect(null, (dispatch) => {
		return {actions: bindActionCreators(tabActions, dispatch)};
	})(DriverSubform);


// WEBPACK FOOTER //
// ./src/components/Form/DriverSubform.js